import { actionCreator, stateChangeOnlyActionCreator } from '../../store/actionCreators';
import {
  DELETE_NOTIFICATIONS_ACTIONTYPE,
  GET_ALL_NOTIFICATIONS_ACTIONTYPE,
  MARK_NOTIFICATIONS_ACK_ACTIONTYPE,
  NOTIF_SELECTED_ACTIONTYPE,
  NOTIF_SELECTED_DEVICE_ACTIONTYPE,
} from './actionTypes';

export const getAllNotificationsAction = actionCreator(GET_ALL_NOTIFICATIONS_ACTIONTYPE);
export const acknowledgeNotificationAction = actionCreator(MARK_NOTIFICATIONS_ACK_ACTIONTYPE);
export const deleteNotificationAction = actionCreator(DELETE_NOTIFICATIONS_ACTIONTYPE);

export const notificationSelectedDeviceAction = stateChangeOnlyActionCreator(NOTIF_SELECTED_DEVICE_ACTIONTYPE);
export const notificationSelectedAction = stateChangeOnlyActionCreator(NOTIF_SELECTED_ACTIONTYPE);
